import React, { useState } from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { Waypoint } from "react-waypoint";

function Main() {
  const [Load, setLoad] = useState(false);
  const data = [
    {
      id: 1,
      icon: "flaticon-money-bag",
      number: "150K+",
      name: "Insurances Provided",
    },
    {
      id: 2,
      icon: "flaticon-community",
      number: "30K",
      name: "Happy Outlets",
    },
    {
      id: 3,
      icon: "flaticon-target",
      number: "99%",
      name: "Success Rate",
    },
  ];

  return (
    <>
      <Waypoint onEnter={() => setLoad(true)}>
        <section className="funfact-one ">
          {Load && (
            <div className="container">
              <div className="sec-title text-center">
                <p className="sec-title__tagline">company statistics</p>

                <h3 className="sec-title__title">
                  We are happy to share our achievement
                </h3>
              </div>
              <div className="container">
              <div className="row gutter-y-30  ">
                {data.map((item) => (
                  <div className="col-md-6 col-lg-6 col-xl-4 ms-auto" key={item.id}>
                    <div className="funfact-one__card">
                      <i className={`funfact-one__card__icon ${item.icon}`} />
                      <h3 className="funfact-one__card__title count-box">
                       
                        {item.number}
                      </h3>

                      <p className="funfact-one__card__text">{item.name}</p>

                      <div className="funfact-one__card__shape" />
                    </div>
                  </div>
                ))}
              </div>
              </div>

              {/* <div className="row">
                <div className="col-md-12 text-center">
                  <div className="funfact-one__info">
                    <span>
                      Find Quality and best price Insurance or any agent
                    </span>
                    <Link
                      to="/pricing"
                      className="thm-btn thm-btn--three funfact-one__info__btn"
                    >
                      <span>
                        Get Started
                        <i className="far fa-arrow-right" />
                      </span>
                    </Link>
                  </div>
                </div>
              </div> */}
            </div>
          )}
        </section>
      </Waypoint>
    </>
  );
}

export default Main;
